import api from "@/lib/callAPI";

async function fileUpload(file, account_id, folder_prefix) {
    if (!file) return;

    // Tạo Promise để đảm bảo hàm trả về kết quả khi quá trình upload hoàn tất
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        const fileName = normalizedSearchValue(file.name).replace(/[\s_]+/g, '-');
        reader.onloadend = async () => {
            let base64 = reader.result.substr(reader.result.indexOf(',') + 1);

            if (file.size > 1 * 1024 * 1024 && file.type !== 'video/mp4') {
                const img = new Image();
                img.src = reader.result;

                img.onload = () => {
                    const MAX_SIZE = 1920;
                    let [width, height] = [img.width, img.height];

                    if (width > height && width > MAX_SIZE) {
                        height *= MAX_SIZE / width;
                        width = MAX_SIZE;
                    } else if (height > MAX_SIZE) {
                        width *= MAX_SIZE / height;
                        height = MAX_SIZE;
                    }

                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(img, 0, 0, width, height);

                    base64 = canvas.toDataURL(file.type).split(',')[1];
                    sendRequest();
                };
            } else {
                sendRequest();
            }

            function sendRequest() {
                const request = {
                    type: file.type,
                    base64: base64,
                    account_id: account_id,
                    file_name: fileName,
                    folder_prefix: folder_prefix,
                    file: {},
                };

                // Gửi yêu cầu tải lên API
                api.post('/api/media/uploadImageToGCS', request)
                    .then(result => {
                        resolve(result);
                    })
                    .catch(err => {
                        reject(err);
                    });
            }
        };
        reader.readAsDataURL(file);
    });
}

function normalizedSearchValue (str) {
    return (str || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s.]/gi, '').toLowerCase().replace(/đ/g, 'd');
}

function generateRandomString(length) {
    return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
}

function generateRandomNumber(length) {
    return [...Array(length)].map(() => Math.floor(Math.random() * 10)).join('');
}

export default {
    generateRandomString,
    generateRandomNumber,
    fileUpload,
};